import { ObjectValues } from '../../app/types/utilityTypes';

export const COMPARE_SUMMARY_NAMES = {
  PERCENTAGE_OF_LID_QUALIFIED_MEMBERS: 'Percentage of LID qualified members',
  ADDITIONAL_LID_QUALIFIED_MEMBERS_NEEDED:
    'Additional number of LID qualified members you need to add',
  TOTAL_MEMBERS: 'Total members',
  MEMBER_COUNT_COMPARISON: 'Member count compared with Call Report',
  MEMBERS_QUALIFIED_AS_LID: 'Members qualified as LID',
  MEMBERS_NOT_QUALIFIED_AS_LID: 'Members not qualified as LID',
} as const;

export type CompareSummaryNames = ObjectValues<typeof COMPARE_SUMMARY_NAMES>;
